import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, TextInput } from "../..";
import { useAppService } from "../../../hooks/use-app-service";
import plusGrayIcon from "../../../_assets/vectors/plus-gray-icon.svg";
import { createMeetingLinkWithToken } from "../../../_pages";
import { DyteService } from "../../../_service";
import { ComponentDisplay } from "../../component-switcher/component-switcher.component";
import { Radio } from "../../form-controls/radio.component";
import IconButton from "../../icon-button.component";
import LiveButton from "../../live-button.component";
import { Modal } from "../../modal.component";

function GoLiveButton({
  group,
  community,
  closeModal = null,
  setIsLoading,
  groupId,
  user,
  tabId,
  title,
}) {
  const [isConfigureMeetingModalVisible, setIsConfigureMeetingModalVisible] =
    useState(false);

  // function to live
  const goLive = () => {
    setIsConfigureMeetingModalVisible(true);
  };

  /* show go live only to admin */
  return (
    <>
      {group && ["admin", "moderator"].includes(group.myRole) ? (
        closeModal ? (
          <IconButton
            icon="img"
            img="/assets/images/create-post/live.png"
            title="Go Live!"
            iconSmall
            label="Go Live"
            className="mx-1"
            onClick={goLive}
          />
        ) : (
          <LiveButton
            onClick={goLive}
            className="w-20 py-3 h-8 space-x-2 shadow hover:shadow-lg font-bold  "
          />
        )
      ) : (
        <></>
      )}
      <MeetingNamePopup
        active={isConfigureMeetingModalVisible}
        setActive={setIsConfigureMeetingModalVisible}
        group={group}
        community={community}
        closeModal={closeModal}
        setIsLoading={setIsLoading}
        groupId={groupId}
        user={user}
        tabId={tabId}
        title={title}
      />
    </>
  );
}

function MeetingNamePopup({
  active = true,
  setActive = () => {},
  group,
  community,
  closeModal = null,
  groupId,
  user,
  tabId,
  title,
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const { analyticsService } = useAppService();

  const [isInstantMeeting, setIsInstantMeeting] = useState(true);
  const [isWebinar, setIsWebinar] = useState(false);
  const [isFormSubmittable, setIsFormSubmittable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // function to live
  const goLive = () => {
    setIsLoading(true);
    // go live
    DyteService.goLive(
      groupId,
      user,
      tabId,
      name,
      description,
      isInstantMeeting ? null : startDate,
      isWebinar
    )
      .then((response) => {
        // get webUrl and meetingId
        const { meetingId } = response;

        analyticsService.track("create-post", {
          userType: community.myRole,
          groupName: group.name,
          sectionName: tabId,
          postType: "live",
          meetingid: meetingId,
        });

        // open the url, only if its instant meeting
        if (isInstantMeeting) {
          window.open(createMeetingLinkWithToken(meetingId, user.token));
        }
        setIsLoading(false);
        // cancel the card
        if (closeModal) closeModal();
        // reload window
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const resetFormAndClose = () => {
    setName("");
    setIsFormSubmittable(false);
    setActive(false);
  };

  return (
    <Modal active={active} padding={false} width="520px" setActive={setActive}>
      {/* headers */}
      <div className="pl-4 pr-2 py-2 theme-bg-surface flex items-center justify-between">
        <span className="font-bold theme-text-heading-2">
          Select Meeting Name
        </span>
        <IconButton
          icon={plusGrayIcon}
          rotate={45}
          onClick={resetFormAndClose}
        />
      </div>
      {/* body */}
      <div className="flex flex-col m-3 theme-bg-surface rounded p-3 theme-text-heading-2">
        <div className="flex flex-col space-y-8">
          {/* meeting name */}
          <div className="flex flex-col">
            <div className="font-bold mb-1 after:content-['*'] after:text-red-500 after:ml-0.5">
              Meeting Name
            </div>
            <TextInput
              placeholder="Meeting Name"
              defaultValue={name}
              className="theme-bg-default"
              validator={(value) => {
                if (value && value.length > 2) {
                  setIsFormSubmittable(true);
                  return null;
                } else {
                  setIsFormSubmittable(false);
                  return "Please use a valid meeting name!";
                }
              }}
              onChange={(value) => {
                setName(value);
              }}
              large
              noMargin
            />
            <div className="text-xs theme-text-subtitle-1 mt-1">
              Suggestions: Group Discussion etc
            </div>

            <div className="font-bold mb-1 mt-4">Description</div>
            <TextInput
              placeholder="Enter description here"
              className="theme-bg-default"
              defaultValue={description}
              onChange={(value) => {
                setDescription(value);
              }}
              large
              noMargin
            />
          </div>

          {/* Meeting Type */}
          <div className="mb-4">
            <div className="font-bold mb-1">Meeting Type</div>
            <div className="flex">
              <Radio
                className="mx-2"
                selected={!isWebinar}
                onClick={() => {
                  setIsWebinar(false);
                }}>
                Group video call
              </Radio>
              <Radio
                className="mx-2"
                selected={isWebinar}
                onClick={() => {
                  setIsWebinar(true);
                }}>
                Webinar
              </Radio>
            </div>
          </div>
          <div className="mb-4">
            <div className="font-bold mb-1">
              When do you want to start the session
            </div>
            <div className="flex">
              <Radio
                className="mx-2"
                selected={isInstantMeeting === true}
                onClick={() => {
                  setIsInstantMeeting(true);
                }}>
                Right now
              </Radio>
              <Radio
                className="mx-2"
                selected={isInstantMeeting === false}
                onClick={() => {
                  setIsInstantMeeting(false);
                }}>
                Schedule for later
              </Radio>
            </div>
          </div>

          {/* Date time picker*/}

          <ComponentDisplay IsDisplay={!isInstantMeeting}>
            <div className="p-3 border rounded theme-bg-default">
              <div className="font-bold mb-1">Set date & time</div>
              <DatePicker
                className="theme-bg-surface  border py-2 px-2 outline-none rounded"
                selected={startDate}
                minDate={new Date()}
                onChange={(date) => setStartDate(date)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="dd - MM - yyyy | h:mm aa"
              />
            </div>
          </ComponentDisplay>
        </div>
      </div>
      {/* submit button */}
      <div className="theme-bg-surface px-5 py-3">
        <div className="mx-auto flex justify-between items-center">
          <Button
            onClick={(e) => {
              resetFormAndClose();
            }}
            flat
            className="p-4"
            label="Cancel"
            large
          />

          <Button
            disabled={!isFormSubmittable}
            onClick={goLive}
            className="p-4"
            label={isInstantMeeting ? "Go Live" : "Schedule"}
            large
            isLoading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}

export { GoLiveButton };
